import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../../../services/user-services/user.service';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NeedHelpComponent} from '../../../../../shared/components/ux/need-help/need-help.component';
import {NgIf} from '@angular/common';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-component-pending',
  templateUrl: './component-pending.component.html',
  styleUrls: ['./component-pending.component.scss'],
  standalone: true,
  imports: [IconComponent, NgIf, NeedHelpComponent, TranslateModule]
})
export class ComponentPendingComponent implements OnInit {

  @Input() public booking;

  public isMobile: boolean = false;
  public agent: any;

  constructor(
    private userService: UserService,
    private router: Router,
    private processService: ProcessService,
  ) {
  }

  ngOnInit(): void {
    if (this.userService.getInfos()) {
      this.processService.getBooking(this.booking.propId).pipe(take(1)).subscribe(async data => {
        this.booking = data.data;
      });
      this.isMobile = this.userService.isMobileUser;
      this.agent = this.userService.userInformations.agent;
    }
  }

  public goToProfile(): void {
    this.router.navigate(['account/my-profile'], {queryParams: {tab: 'purchase'}});
  }

}
